import { render, staticRenderFns } from "./index.vue?vue&type=template&id=06fc98ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=06fc98ca&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fc98ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06fc98ca')) {
      api.createRecord('06fc98ca', component.options)
    } else {
      api.reload('06fc98ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=06fc98ca&scoped=true", function () {
      api.rerender('06fc98ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/collectInfo/index.vue"
export default component.exports